<template>
  <div>
    <SpFilterForm :model="formData" size="small" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="item_name">
        <el-input v-model="formData.item_name" clearable placeholder="请输入商品名称" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="task_code">
        <el-input v-model="formData.task_code" clearable placeholder="请输入顺丰微派任务编码" />
      </SpFilterFormItem>
    </SpFilterForm>
    <SpFinder
      ref="finder"
      row-key="id"
      :split-count="10"
      :url="table_url"
      :setting="setting"
      fixed-row-action
      reserve-selection
      no-selection
      :hooks="{
        beforeSearch
      }"
    >
      <template slot="tableTop">
        <el-button type="primary" size="medium" @click="addChange">添加</el-button>
      </template>
    </SpFinder>
    <GoodsSelect
      :items-visible="visible"
      :is-spu=true
      :support_gov_subsidy="1"
      :item-tier="itemNormal"
      row-key="item_id"
      :get-status="itemStatus"
      :rel-items-ids="subsidyItems"
      @chooseStore="chooseItemsAction"
      @closeStoreDialog="handleClose"
    ></GoodsSelect>
  </div>
</template>
<script>
import { useDialog } from '@shopex/finder'
import GoodsSelect from '@/components/goodsSelect'
import { tableSetting } from './config'
import { List, createActivityCodes, setActivityItems } from './api'

export default {
  components: {
    GoodsSelect
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  data () {
    return {
      table_url: List,
      visible: false,
      rowData: {},
      subsidyItems: [],
      itemStatus: false,
      itemNormal: [
        'normal',
      ],
      formData: {
        item_name: '',
        task_code: '',
      }
    }
  },
  mounted() {
  },
  methods: {
    beforeSearch (param) {
      return {
        ...param,
        page_size: param.pageSize,
        ...this.formData
      }
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    onReset() {
      this.formData = {}
      this.refresh()
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    addItems (row) {
      this.visible = true
      this.rowData = row
      this.itemStatus = true
      this.subsidyItems = []
    },
    async handleClose () {
      this.visible = false
      this.itemStatus = false
      this.rowData = {}
      this.subsidyItems = []
    },
    async chooseItemsAction (data) {
      if (data === null || data.length <= 0) return this.$message.error('请选择商品')
      const goods_id = data.map(item => item.goods_id).join(',')
      await setActivityItems({
        task_code: this.rowData.task_code,
        goods_id,
        mode: 'increment'
      })
      this.$message.success('添加成功')
      this.refresh()
      this.handleClose()
    },
    addChange () {
      useDialog(null, {
        title: `新增顺丰微派编码`,
        width: '50%',
        component: () => import('./comps/createForm.vue'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '提交', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(async (arg) => {
        if(arg) {
          try {
            await createActivityCodes(arg)
            this.$message.success('新增成功')
            this.refresh()
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    showGoods (row) {
      console.log(row, 'row')
      useDialog(null, {
        title: `查看商品列表`,
        width: '70%',
        component: () => import('./comps/goodList.vue'),
        orgData: {
          task_code: row.task_code,
          vm: this
        },
        actions: []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.nationalmanage-header {
  display: flex;
  justify-content: space-between;
  align-items: center
}
</style>
<style lang="scss">

</style>

